<template>
  <div class="l-container-inner">
    <Event v-for="event in this.events.slice().reverse()" :key="event.id" :event='events[event.id]'></Event>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Event from '@/components/Event'

export default {
  name: 'Events',
  computed: {
    ...mapGetters(['getEvents']),
    events () {
      return this.getEvents
    }
  },
  components: {
    Event
  }
}
</script>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// src/views/Events.vue